import React from 'react';

import SidebarIconButton from './SidebarIconButton';

interface InlineAddViewButtonProps {
  onClick: () => void;
  disabledReason: string | null;
}

/** @package */
export default function InlineAddViewButton({
  onClick,
  disabledReason,
}: InlineAddViewButtonProps): JSX.Element {
  const disabled = disabledReason != null;
  return (
    <SidebarIconButton
      tooltip={disabledReason ?? 'Add view'}
      onClick={onClick}
      ariaLabel="Add view"
      dataTestComponent="InlineAddViewButton"
      disabled={disabled}
      icon="compose"
    />
  );
}
